import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
import { AppUtilService } from '../../core/utils/app-util.service';
import { UserService } from '../../core/services/user.service';
import { UserProperty, CacheConstant } from '../../core/constants/app.constant';
import { ParmedApiService as ParmedApi } from '../../core/api/parmed-api.service';
import { execute } from '../products/products.service-helper';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../core/services/init/app-config.service';

@Injectable()
export class OktaService {
  /***************Properties***************/
  /***************Properties***************/

  /***************Constructor***************/
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  constructor(
    private cache: AppCacheService,
    private userService: UserService,
    private http: HttpService,
    private api: ParmedApi,
    private configService: AppConfigService
  ) {}
  /***************Constructor***************/

  /***************Service Methods***************/

  verifyToken(token: string) {
    return this.http.post(this.api.Auth.VERIFY_TOKEN_URL, {
      recoveryToken: token,
      buId: this.envProperties.buId
    });
  }

  isMigrated(username) {
    return this.http.post(this.api.Login.IS_USER_MIGRATE_URL, {
      username: username
    });
  }

  activate(activateUserObj: any) {
    return this.http.post(this.api.Auth.ACTIVATE_USER_URL, activateUserObj);
  }

  activateNonMigrate(userObj) {
    return this.http.post(
      this.api.Login.ACTIVATE_NON_MIGRATED_USER_URL,
      userObj
    );
  }

  sendResetPasswordEmail(userId: string) {
    return execute(this.http, this.api.Auth.FORGOT_PASSWORD_URL, {
      userId: AppUtilService.getUserSuffixId(userId),
      buId: this.envProperties.buId
    }, undefined, this.configService);
  }

  verifySecurityAnswer(answer: string, stateToken: string) {
    const body = { answer: answer, stateToken: stateToken , buId: this.envProperties.buId};
    return this.http.post(this.api.Auth.VERIFY_SECURITY_ANSWER_URL, body);
  }

  resetPassword(resetPasswordObj: any) {
    return this.http.post(this.api.Auth.RESET_PASSWORD_URL, resetPasswordObj);
  }

  getSecurityQuestions(oktaId?: any) {
    const body = {
      oktaId: oktaId || this.userService.getProperty(UserProperty.OktaId),
      buId: this.envProperties.buId
    };
    return this.http.post(this.api.Auth.GET_SECURITY_QUESTIONS_URL, body);
  }

  updateSecurityQuestion(question: string, answer: string) {
    const body = {
      oktaUserId: this.userService.getProperty(UserProperty.OktaId),
      recoveryQuestion: {
        answer: answer,
        question: question
      }
    };

    return this.http.post(this.api.Auth.UPDATE_SECURITY_QUESTION_URL, body);
  }

  changePassword(oldPassword: string, newPassword: string) {
    const changePasswordObj = {
      oldPassword: oldPassword,
      newPassword: newPassword,
      oktaUserId: this.cache.get(CacheConstant.Okta_User_Id)
    };

    return execute(this.http, this.api.Auth.CHANGE_PASSWORD_URL, changePasswordObj, undefined, this.configService);
  }

  sendUnlockAccountEmail(userId: string) {
    return this.http.post(this.api.Auth.UNLOCK_ACCOUNT_URL, {
      userId: AppUtilService.getUserSuffixId(userId),
      buId: this.envProperties.buId
    });
  }

  getVerifyToken(userId: string) {
    return this.http.post(this.api.Auth.GET_VERIFY_TOKEN_URL, {
      username: userId,
      buId: this.envProperties.buId
    });
  }

  /***************Service Methods***************/
}
